import BluePlusButton from './BluePlusButton.vue'
import WhitePlusButton from './WhitePlusButton.vue'
export default {
    BluePlusButton,
    WhitePlusButton,    
}